export const environment = {
  production: true,
  urlBase: 'https://clientesparcel.dhl.es/LiveTracking.GTW/',
  claveMaps: 'AIzaSyCW4rG5spxRbVhv0Yoir266S1qa2jzLyMw',
  useCookies: true,
  cookiesScript: '54a336d0-5876-4019-affe-6ca37174d4a3',
  googleAnalyticsId: 'G-3FSW5XKN6H',
  directoryImages: './',
  plantillaURLSeguimiento: 'https://clientesparcel.dhl.es/seguimientoenvios/integra/SeguimientoDocumentos.aspx?codigo=#expedition&anno=#año&lang=#lenguaje',
  indiceFichaSeleccionadaCabecera: 0,
  offline: false,
  textosTiempoOffline: null,
  tituloAviso: null,
  textoAviso: null,
  startDateWarning: null,
  fechaFinAviso: null
};
